import Cookies from 'js-cookie'

export const TOKEN_KEY = process.env.VUE_APP_TOKEN

export function getToken() {
  return Cookies.get(TOKEN_KEY)
}

export function setToken(TOKEN_VALUE: string) {
  return Cookies.set(TOKEN_KEY, TOKEN_VALUE)
}

export function removeToken() {
  return Cookies.remove(TOKEN_KEY)
}
